import { useNavigate } from "react-router-dom";
import {
  CTBProgram,
  ProgramType
} from "../../utils/api/endpoints/programs/parsePrograms";
import Pill from "../pills/Pill";
import PrimaryButton from "../buttons/PrimaryButton";
import QuickViewModal, { QuickViewSection } from "../modal/QuickViewModal";
import ProfileQuickLook from "../profile/ProfileQuickLook";
import PayoutRangeDisplay from "./PayoutRangeDisplay";
import RichTextRenderer from "../common/RichTextRenderer";
import ProgramTargets from "./ProgramTargets";

const formatProgramType = (type?: ProgramType): string => {
  return type === ProgramType.PTAAS ? "PTaaS" : type || "";
};

const ProgramQuickView = ({
  program,
  onClose
}: {
  program?: CTBProgram;
  onClose: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <QuickViewModal
      title={<RichTextRenderer content={program?.title || ""} />}
      enabled={program !== undefined}
      onClick={onClose}
      className="flex flex-col"
    >
      <section id="123" className="flex h-full flex-col gap-3 overflow-y-auto">
        <div className="flex items-center justify-between">
          {program?.creator ? (
            <ProfileQuickLook
              title={program.creator.displayName}
              subtitle={program.updatedAt}
              imageSrc={program.creator.pfp}
            />
          ) : (
            <div />
          )}

          {program?.payoutRange && program.type === ProgramType.BugBounty && (
            <PayoutRangeDisplay
              payoutRange={program.payoutRange}
              className="text-xl"
            />
          )}
        </div>

        <div className="flex items-stretch gap-2 text-sm leading-[150%]">
          <Pill
            label={program?.private ? "Private" : "Public"}
            className="flex items-center bg-ctb-blue-50 px-2"
          />

          {program?.type && (
            <Pill
              label={formatProgramType(program.type)}
              className="flex items-center bg-ctb-blue-50 px-2 text-sm"
            />
          )}
        </div>

        {program?.description && (
          <QuickViewSection>
            <RichTextRenderer content={program.description} />
          </QuickViewSection>
        )}

        {program?.rewardPolicy && (
          <QuickViewSection title="Reward Policy">
            <RichTextRenderer content={program.rewardPolicy} />
          </QuickViewSection>
        )}

        {program?.targets && program.targets.length > 0 && (
          <QuickViewSection title="Targets" className="flex gap-3">
            <ProgramTargets program={program} />
          </QuickViewSection>
        )}
      </section>

      <PrimaryButton
        type="button"
        className="mt-10 w-full"
        onClick={() => program && navigate(`${program.id}`)}
      >
        View Full Details
      </PrimaryButton>
    </QuickViewModal>
  );
};

export default ProgramQuickView;
